var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrandImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_207_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "url(#paint0_linear_207_4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.792 81.37C38.9307 81.37 35.6993 81.1233 32.098 80.63C30.1247 80.3833 28.768 79.8653 28.028 79.076C27.288 78.2867 26.9673 77.004 27.066 75.228C27.4113 70.344 28.2253 64.3253 29.508 57.172C30.7907 49.9693 32.3447 43.038 34.17 36.378C34.5153 35.1447 35.206 34.2813 36.242 33.788C37.278 33.2947 38.6347 33.048 40.312 33.048C43.3213 33.048 44.826 33.8867 44.826 35.564C44.826 36.2547 44.678 37.044 44.382 37.932C43.0993 41.8787 41.8167 47.182 40.534 53.842C39.2513 60.4527 38.3387 66.7673 37.796 72.786C39.276 72.934 40.9533 73.008 42.828 73.008C51.4613 73.008 57.8993 70.3933 62.142 65.164C66.434 59.9347 68.58 52.954 68.58 44.222C68.58 38.3513 66.9027 33.8127 63.548 30.606C60.1933 27.3993 55.4573 25.796 49.34 25.796C45.3933 25.796 41.4713 26.4127 37.574 27.646C33.726 28.8793 30.248 30.5073 27.14 32.53C26.4987 32.974 25.808 33.196 25.068 33.196C24.2293 33.196 23.5633 32.8507 23.07 32.16C22.5767 31.42 22.33 30.532 22.33 29.496C22.33 28.312 22.5273 27.35 22.922 26.61C23.3167 25.8207 23.9827 25.1053 24.92 24.464C28.324 22.1453 32.32 20.394 36.908 19.21C41.496 17.9767 45.9113 17.36 50.154 17.36C56.1727 17.36 61.3773 18.4207 65.768 20.542C70.1587 22.614 73.538 25.6727 75.906 29.718C78.274 33.7633 79.458 38.6473 79.458 44.37C79.458 51.8193 77.978 58.3313 75.018 63.906C72.058 69.4313 67.7413 73.7233 62.068 76.782C56.3947 79.8407 49.636 81.37 41.792 81.37Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_207_4",
    x1: 17.5,
    y1: 18.5,
    x2: 78,
    y2: 91.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15A4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0572E6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_207_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandImage);
export default __webpack_public_path__ + "static/media/Brand-image.07af0344d0f5685ca07960b855259656.svg";
export { ForwardRef as ReactComponent };